module.exports = __webpack_public_path__ + "static/0039-acf0cc4d9a7d3025e53ee6f27a84fd98.png";